<script setup lang="ts">
interface NotificationProps { type: 'success' | 'error' | 'info' | 'warning' }

const emits = defineEmits(['close'])
defineProps<NotificationProps>()

const styles = computed(() => ({
  success: {
    bg: 'bg-[#F0F7F0]',
    border: 'border-[#4CAF50]',
    text: 'text-[#1E4620]',
    icon: 'lucide:circle-check',
    iconColor: 'text-[#4CAF50]'
  },
  error: {
    bg: 'bg-[#FFF0F0]',
    border: 'border-[#D32F2F]',
    text: 'text-[#621B16]',
    icon: 'lucide:x-circle',
    iconColor: 'text-[#D32F2F]'
  },
  info: {
    bg: 'bg-[#F0F7FF]',
    border: 'border-[#2196F3]',
    text: 'text-[#014361]',
    icon: 'lucide:circle-alert',
    iconColor: 'text-[#2196F3]'
  },
  warning: {
    bg: 'bg-[#FFF7E6]',
    border: 'border-[#FFA000]',
    text: 'text-[#663C00]',
    icon: 'lucide:triangle-alert',
    iconColor: 'text-[#FFA000]'
  }
}))
</script>

<template>
  <div :class="[
    'flex relative items-center gap-3 px-4 py-3 ml-auto rounded-md border w-fit max-w-96 shadow-lg',
    styles[type].bg, styles[type].border
  ]">
    <button
      type="button"
      class="absolute text-zinc-500 -top-1 right-1"
      @click="emits('close', $event)"
    ><icon icon="mdi:close" /></button>
    <icon :icon="styles[type].icon" class="h-5 w-5" :class="styles[type].iconColor" />
    <p :class="['text-sm font-medium', styles[type].text]"><slot></slot></p>
  </div>
</template>

